import React ,{ useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux'
import './App.css';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import ToolBox from './viewer/ToolBox.js';
import { setAuthInfo, setLoading} from './actions/main.js'
import { setSearchKeySelect, setSearchPulldownValue, setSearchOptions } from './actions/searchbox'
import { setOpenCompanyProfile, setCustomStyles } from './actions/ui.js'
import { parseToken, getTokenCookie, setCookie,assetUrl } from './utils/Common.js'
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import DownloadIcon from '@mui/icons-material/Download';
import VideocamIcon from '@mui/icons-material/Videocam';
import axios from 'axios';
import LoadingOverlay from 'react-loading-overlay';
import ScaleLoader from 'react-spinners/ScaleLoader'
import LeftProfile from  './viewer/component/LeftProfile.js';
import { useParams } from 'react-router-dom'
import { ESHOW_URL } from './config.js'
import ReactPlayer from 'react-player'
import FeaturedLabel from './viewer/component/FeaturedLabel.js';
import { makeStyles } from '@mui/styles';
import ReactReadMoreReadLess from "react-read-more-read-less";
import SearchBox from './viewer/component/SearchBox.js';
import Footer from './viewer/component/Footer.js';


function paginate(array, page_size, page_number) {
  return array.slice((page_number - 1) * page_size, page_number * page_size);
}

function Index(props) {
  const { id1, id2, id3, id4, id5 } = useParams();
  const [data, setData] = useState([]);
  const [dataFetched, setDataFetched] = useState(false);
  const [page, setPage] = React.useState(1);
  const [filteredItems, setFilteredItems] = useState([])
  const page_size = 24;
  
  let standardSearchOptions = props.searchbox.searchOptions?.STANDARD??[]
  let keySelect = props.searchbox?.searchKeySelect
  let pulldownValue = props.searchbox?.searchPulldownValue
  let searchInputValue = props.searchbox?.searchInputValue
  var selectedAdvancedFilterOptions = props.searchbox.selectedAdvancedFilterOptions
  
  const useStyles = makeStyles((theme) => ({
    searchBtn:{
      backgroundColor: props.ui?.customStyles?.['search-button-bg-color']?(props.ui?.customStyles['search-button-bg-color']+"!important"):'#1565c0',
      color: props.ui?.customStyles?.['search-button-label-color']?(props.ui?.customStyles['search-button-label-color']+"!important"):'#1565c0',
    },
    bubble:{
      color:props.ui?.customStyles?.['bubble-label-color']?(props.ui?.customStyles['bubble-label-color']+"!important"):'white',
      backgroundColor:props.ui?.customStyles?.['bubble-bg-color']?(props.ui?.customStyles['bubble-bg-color']+"!important"):'#1565c0',
    }
  }));
  const classes = useStyles();
  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const openCompanyProfile=(exhibitor)=>{   
    var booth = {};
    booth.exhibitors = [{EXHIBITOR_KEY: exhibitor.EXHIBITOR_KEY}]
    booth.booth_number = exhibitor?.BOOTH_NO

    props.setOpenCompanyProfile({booth:booth, open:true})
  }

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fafafa',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    display:'block'
  }));

  const debounce = (func, delay) => {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  };

  const fetchData = ()=>{    
    if(props.urlToken){
      var public_token = `/${id1}`
        if(id2){
          public_token = `${public_token}/${id2}`
        }
        if(id3){
          public_token = `${public_token}/${id3}`
        }
        if(id4){
          public_token = `${public_token}/${id4}`
        }
        if(id5){
          public_token = `${public_token}/${id5}`
        }
        setCookie('V3PUBLICMAP', public_token)
    }
    props.setLoading(true)
    var url = `${ESHOW_URL()}?method=getSponsors&list_type=page` 
    const options = {
      headers: {
        'Authorization': `Bearer ${getTokenCookie()}`
      }
    } 
    axios.get(url, options).then(res=>{
        const result = res.data;
        if(result.SUCCESS){  
          props.setSearchOptions(result.SEARCH) 
          if(result.SPONSORS){
            setData(result.SPONSORS)       
          }
        }
        else{
          setData([])
        }
        setDataFetched(true)
        props.setLoading(false)
    }).catch(error => {
      props.setLoading(false)
    })  
  }

  useEffect(() => {
    document.getElementsByTagName("body")[0].style.overflowY='scroll'
    props.setOpenCompanyProfile(false)
    fetchData()
  }, [id5, id4, id3, id2, id1])

  useEffect(() => {
    if(data.length)
      doSearch()
  }, [data])

  useEffect(() => {
    if(data.length)
      debouncedSearch()
  }, [keySelect, pulldownValue, searchInputValue, selectedAdvancedFilterOptions])  
    
  const doSearch=(value)=>{  
    setPage(1);
    var keyword = null
    let searchOption = getSearchOption(keySelect)
    if(value){
      keyword = value
    }
    else{
      if(searchOption && (searchOption.TYPE == 'pulldown' || searchOption.TYPE == 'checkbox')){
        keyword = pulldownValue
      }
      else{
        keyword = searchInputValue
      }
    }
    if(!keyword) keyword = ''
    keyword = `${keyword}`
    var filteredItems = data;
    if(keyword == "" || keyword == '""' || !keyword){
      setFilteredItems(filteredItems)
      return;
    }
    if(keyword && keyword.trim() !== '') {
      filteredItems = data.filter((item)=>{
        var str = ''
        if(keySelect == "product_description"){
          str = `${item?.DESCRIPTION?item?.DESCRIPTION:''}`
          return (str.toLowerCase().includes(keyword.toLowerCase()))
        }
        else if(keySelect == "exhibitor_name"){
          str = `${item?.COMPANY_NAME?item?.COMPANY_NAME:''}`
          return (str.toLowerCase().includes(keyword.toLowerCase()))
        }
        else if(keySelect == "product_category"){
          var categories = item?.CATEGORY;
          var keys = [];
          for(var i = 0; i< categories?.length; i++){
            keys.push(categories[i].ANSWER_KEY)
          }
          return (keys?.includes(keyword))
        }        
        else if(keySelect == 'new_product'){
          str = `${item?.NEW_PRODUCT?item?.NEW_PRODUCT:''}`
          return (str.toLowerCase().includes(keyword.toLowerCase()))
        }     
        else{
          var categories = item.CATEGORY;
          var keys = [];
          for(var i = 0; i< categories?.length; i++){
            keys.push(categories[i].ANSWER_KEY)
          }
          return (keys?.includes(keyword))
        }
      })      
    }
    setFilteredItems(filteredItems)
  }
  
  const debouncedSearch = debounce(doSearch, 300);

  const getSearchOption = (value)=>{
    if (!value) return false;
    for(var i = 0; i < standardSearchOptions?.length; i++){
      if(standardSearchOptions[i].ID == value){
        return standardSearchOptions[i]
      }
    }
    return false
  }
  
  let pageData = Object.entries(
    filteredItems.reduce((acc, item) => {
      const level = item.LEVEL;
      if (!acc[level]) acc[level] = [];
      acc[level].push(item);
      return acc;
    }, {})
  ).map(([key, children]) => ({ key, children }))

  // var pageData = paginate(filteredItems, page_size, page);
  var banner = props.main.showSetup?.PUBLIC?.HEADER_BANNER;
  if(banner == "undefined") banner = null
  var download_show = true
  var contact_show = true
  if(props.main.showSetup?.PUBLIC?.DOWNLOAD_LINKS == 'hide'){
    download_show = false
  }
  if(props.main.showSetup?.PUBLIC?.CONTACT_INFO == 'hide'){
    contact_show = false
  }
  
  return (
    <Box id="xhbt-main-container" className="App Client">
      <ToolBox {...props}/>
      <Box className="xhbt-data-box" style={{maxWidth: 1200, margin:'64px auto', paddingLeft: 10, paddingRight:10, marginTop:(banner && banner != ''?(150+64):64)}}>
        <Box textAlign={'center'}>
          {/* <SearchBox/> */}
        </Box>
        <Box mt={2}>
          <div>
            {
              pageData.map((block, block_index)=>{
                return(
                  <div key={block_index}>
                    <h4 className='sponsor-block-header'>{block.key}</h4>
                    <Grid container spacing={2}>
                    {
                      block.children?.map((item, index)=>{
                        return(
                          <Grid key={index} item xs={12} sm={6} md={4} lg={3}>
                            <Item  variant="outlined" square style={{position:'relative', padding:0}}>
                                {item?.NEW_PRODUCT == 1&&
                                <img width="66px" style={{position:'absolute', left:'-1px', top:'-1px'}} src="/asset/new_product.png" />
                                }
                                {item?.FEATURED &&
                                <Box>
                                  <FeaturedLabel moreClass='feet-content'/>
                                </Box>
                                }
                                {item?.HEADERIMAGE &&
                                <>
                                {
                                  item?.HEADERIMAGE?.includes(".mp4")?
                                  <ReactPlayer controls muted={true} playing={true} className="" url={item?.HEADERIMAGE} width="100%" height="80px"/>:
                                  <div style={{width:'100%'}}>
                                    <img style={{width:'100%', objectFit:'cover'}} width="auto" height="100px" src={`${assetUrl(item?.HEADERIMAGE)}`}/>
                                  </div>
                                }
                                </>
                                }
                                <Box style={{padding:8}}>
                                  {item?.DOCUMENT &&  download_show &&
                                  <Box sx={{textAlign:'right'}}>
                                    {item?.DOCUMENT_TYPE == 'video'?              
                                    <a className='round-icon-btn' style={{marginLeft:'auto',marginRight:'10px'}} target='_blank' href={item?.DOCUMENT}>
                                      <VideocamIcon style={{color:'white'}}/>
                                    </a>:
                                    <a className='round-icon-btn' style={{marginLeft:'auto',marginRight:'10px'}} target='_blank' download href={item?.DOCUMENT}>
                                      <DownloadIcon style={{color:'white'}}/>
                                    </a>
                                    }
                                  </Box>
                                  }
                                  <Box mt={1}>
                                    <b class="card-title">{item?.TITLE}</b>  
                                    {item?.DESCRIPTION&&                      
                                    <Box className='show-more-div' mt={1} style={{minHeight:'70px', textAlign:'left'}}>
                                      {/* <ShowMore
                                          lines={4}
                                          more='Read More'
                                          less='Read Less'
                                          anchorClass=''
                                      >
                                        {item?.DESCRIPTION} 
                                      </ShowMore> */}
                                      <ReactReadMoreReadLess
                                          charLimit={200}
                                          readMoreText={"Read more"}
                                          readLessText={"Read less"}
                                      >
                                        {item?.DESCRIPTION} 
                                      </ReactReadMoreReadLess>
                                    </Box>
                                    }
                                  </Box>              
                                  <Box mt={1}>
                                    <a href="javascript:void(0)" onClick={()=>{openCompanyProfile(item)}}>
                                      <b >{item.COMPANY_NAME}</b><br/>
                                    </a>
                                    {item.PRIMARY_BOOTH &&
                                    <><span>Booth: {item.PRIMARY_BOOTH}</span><br/></>
                                    }
                                    {item.MAP_NAME &&
                                    <span>Map: {item.MAP_NAME}</span>
                                    }
                                  </Box>   
                                  {assetUrl(item?.LOGO) &&
                                  <Box mt={1}>          
                                    <img width="auto" height="80px" style={{maxWidth:'100%'}} src={`${assetUrl(item?.LOGO)}`}/>
                                  </Box>  
                                  }
                                  <Box mt={1} style={{textAlign: 'center'}}>
                                    {
                                      item?.CATEGORY?.map((category, catInd)=>{
                                        return(
                                          <Chip className={classes.bubble} size="small" style={{margin: '0px 3px 3px', cursor:'pointer'}} key={catInd} label={category.ANSWER_TITLE} 
                                            onClick={()=>{
                                                props.setSearchKeySelect('Product Category');  
                                                props.setSearchPulldownValue(category.ANSWER_KEY); 
                                            }} color="primary" />
                                        )
                                      })
                                    }
                                  </Box>
                                </Box>
                            </Item>
                          </Grid>
                        )
                      })
                    }
                    </Grid>
                  </div>
                )
              })
            }
            {
              (!data || data.length == 0) && dataFetched && 
              <Box style={{textAlign:'center', width:'100%'}}>
                <label>No Show Case Found.</label>
              </Box>
            }
          </div>
        </Box>
      </Box>
      {/* <Box mt={3} mb={8}>
        <Stack spacing={2}>
          <Pagination variant="outlined" shape="rounded" style={{justifyContent:'center'}} count={Math.ceil(data.length/page_size)} color="primary"  page={page} onChange={handleChangePage}/>
        </Stack>
      </Box> */}
      <Footer/>
      <LeftProfile groupOptions = {[]}/>
      {props.ui?.customStyles?.['loaded'] &&
      <LoadingOverlay
            active={props.main.loadingFlag}
            fadeSpeed = {100}
            styles={{
                overlay: (base) => ({
                ...base,
                fontSize:'18px',
                color: 'rgb(5, 37, 51)',
                // background: 'rgb(229 229 229 / 92%)',
                background: 'transparent',
                position:'fixed',
                top: '49px',
                zIndex:1000000000
                })
            }}
            spinner = {<ScaleLoader color={props.ui?.customStyles?.['spinner-color']?props.ui?.customStyles['spinner-color']:'#1976d2'} radius={2.5} margin={2.5} height={40} width={5}/>}
            // spinner
            // text='Loading ...'
            >
        </LoadingOverlay> 
        }
    </Box>
  );
}


const mapStateToProps = (state) => {
  return {
    main: state.main,
    booth_history: state.booth_history.present,
    ui: state.ui,
    cart: state.cart,
    searchbox: state.searchbox,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
      setCustomStyles: data=>dispatch(setCustomStyles(data)),
      setAuthInfo:  data=>dispatch(setAuthInfo(data)), 
      setLoading:  data=>dispatch(setLoading(data)),
      setOpenCompanyProfile:  data=>dispatch(setOpenCompanyProfile(data)),
      setSearchKeySelect:  data=>dispatch(setSearchKeySelect(data)),
      setSearchPulldownValue:  data=>dispatch(setSearchPulldownValue(data)),
      setSearchOptions:  data=>dispatch(setSearchOptions(data)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
